import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { DateButtonFilterComponent } from "./filter-bar/date-button-filter/date-button-filter.component";
import { DriverButtonFilterComponent } from "./filter-bar/driver-button-filter/driver-button-filter.component";
import { FilterBarComponent } from "./filter-bar/filter-bar.component";
import { GroupButtonFilterComponent } from "./filter-bar/group-button-filter/group-button-filter.component";
import { ItemFilterComponent } from "./filter-bar/item-filter/item-filter.component";
import { CombinedResourceFilterComponent } from "./filters/combinedResourceFilter.component";
import { DateResourceFilterComponent } from "./filters/dateResourceFilter.component";
import { DriverResourceFilterComponent } from "./filters/driverResourceFilter.component";
import { GeofenceResourceFilterComponent } from "./filters/geofenceResourceFilter.component";
import { GroupResourceFilterComponent } from "./filters/groupResourceFilter.component";
import { ObservationsResourceFilterComponent } from "./filters/observationsResourceFilter.component";
import { TableColumnResourceFilterComponent } from "./filters/tableColumnResourceFilter.component";
import { TagsResourceFilterComponent } from "./filters/tagsResourceFilter.component";
import { VehicleResourceFilterComponent } from "./filters/vehicleResourceFilter.component";
import { NewResourceFilterBarComponent } from "./newResourceFilterBar.component";
import { ResourceFilterBarModalComponent } from "./resourceFilterBarModal.component";

angular
    .module("app.resourceFilters.directives", [])

    .component("newResourceFilterBar", new NewResourceFilterBarComponent())
    .component("combinedResourceFilter", new CombinedResourceFilterComponent())
    .component("driverResourceFilter", new DriverResourceFilterComponent())
    .component("vehicleResourceFilter", new VehicleResourceFilterComponent())
    .component("tagsResourceFilter", new TagsResourceFilterComponent())
    .component("observationsResourceFilter", new ObservationsResourceFilterComponent())
    .component("geofenceResourceFilter", new GeofenceResourceFilterComponent())
    .component("groupResourceFilter", new GroupResourceFilterComponent())
    .component("dateResourceFilter", new DateResourceFilterComponent())
    .component("tableColumnResourceFilter", new TableColumnResourceFilterComponent())
    .component("resourceFilterBarModal", new ResourceFilterBarModalComponent())

    .directive("filterBar", downgradeComponent({ component: FilterBarComponent }))
    .directive("itemFilter", downgradeComponent({ component: ItemFilterComponent }))
    .directive("driverButtonFilter", downgradeComponent({ component: DriverButtonFilterComponent }))
    .directive("dateButtonFilter", downgradeComponent({ component: DateButtonFilterComponent }))
    .directive("groupButtonFilter", downgradeComponent({ component: GroupButtonFilterComponent }))
    ;
